import React from 'react';

import { flagStyles } from '../settings';

const SvgSO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4896px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSO;
